<template>
  <div>
    <b-modal
      size="lg"
      centered
      hide-footer
      title="Detalhes da Notificação"
      header-bg-variant="orange"
      header-text-variant="light"
      v-model="open"
    >
      <b-container>
        <div class="mt-2">
          <span class="fs-18"><strong>Titulo da notificação: </strong> {{ fields.title }}</span>
        </div>

        <div class="mt-2">
          <span class="fs-18"><strong>Texto da notificação: </strong> {{ fields.text }}</span>
        </div>

        <!-- <div class="mt-2">
          <span class="fs-18"><strong>Imagem da notificação:</strong> {{ fields.image }}</span>
        </div> -->

        <div class="mt-2">
          <span class="fs-18"><strong>Data do envio: </strong>{{ formatDate(fields.date_send) }} </span>
        </div>

        <div class="mt-4 d-flex justify-content-end">
          <b-button 
              variant="danger"
              @click="open = false"
            >
            <i class="fas fa-ban mr-2"></i>
              Fechar
            </b-button>
        </div>

      </b-container>
    </b-modal>
  </div>
</template>

<script>

export default {
  data() {
    return {
      open: false,
      fields: {}
    }
  },

  methods: {
    toggleOpen(data) {
      this.open = !this.open;
      const dataNotification = data;
      this.fields = dataNotification.data;
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
    },
  }
}
</script>
